// @flow
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Input,
  AutoComplete,
  Button,
  Notification,
} from "components/Atoms";
import { H6 } from 'components/CustomTypography';
import CustomFlexBox from 'components/CustomFlexBox';

import "./style.scss";
import * as Actions from "actions";
import * as ActionTypes from "constants/ActionTypes";

import AdminShopSalesLog from "components/elements/admin/shops/AdminShopSalesLog";
import AdminShopSalesLogSettingEditor from "components/elements/admin/shops/AdminShopSalesLogSettingEditor";

import MockProductList from "components/elements/main/MockProductList";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {Box, Container, Grid, IconButton, MenuItem} from "@mui/material";
import {useHistory} from "react-router";
import {
  checkUserAllowed,
  getAdminShopFilterList, getAdminShopLogPriorityFilterList,
  getAdminShopLogReasonList,
  getAdminShopLogStatusList, getAdminShopStatusLogFilterList
} from "helpers/utils";
import SelectFieldComponent from "components/SelectField";
import ButtonComponent from "components/Button";
import DatePicker from "react-datepicker";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CustomSectionCreator from "components/CustomSectionCreator";


const AdminSalesLogMain = (props) => {

  const [state, setState] = useState({
    limit: 5,
    hasMoreItems: true,
    breakPoint: "lg",
    bShowSearchModal: false,
  });

  const [saleslogModeState, setSaleLogModeState] = useState("PREVIEW");
  const [saleslogState, setSaleLogState] = useState("");
  const [filterState, setFilterState] = useState("");
  const [statusState, setStatusState] = useState("");
  const [shopStatusState, setShopStatusState] = useState("");
  const [executiveState, setExecutiveState] = useState("");
  const [logPriorityState, setLogPriorityState] = useState("");
  const [startdateState, setStartdateState] = useState(new Date(new Date().getTime() + 24 * 60 * 60 * 1000));
  const [offsetState, setOffsetState] = useState(0);

  const {
    serviceError, reqStatus, isLoading, bootupInfo, execList, userDetails,
    adminUpdateSalesLogStatus, adminSearchShopSalesLog, saleslogs,
    adminGetSalesExecutives
  } = props;

  useEffect(() => {
    adminSearchShopSalesLog();
    adminGetSalesExecutives();
  }, []);

  const sendNotification = (type, { title, description = "" }) => {
    Notification[type]({
      message: title,
      description,
    });
  };

  useEffect(() => {
    if (serviceError && reqStatus) {
      const feedback = {
        title: serviceError,
        description: serviceError,
      };
      sendNotification("error", feedback);
    }
    switch (reqStatus) {
      case ActionTypes.ADMIN_UPDATE_STORE_SALES_LOG_SUCCESS:
        adminSearchShopSalesLog(filterState, statusState, startdateState, executiveState, shopStatusState, logPriorityState, offsetState);
        break;
      default:
        break;
    }
  }, [serviceError, reqStatus]);

  const updateSaleLogStatusCall = (data) => {
    adminUpdateSalesLogStatus(data);
    setSaleLogModeState("PREVIEW");
  };

  const handleSalesLogSetting = (mode, item) => (e) => {

    setSaleLogModeState(mode);

    setSaleLogState({
      selectedSaleLog: {
        _id: item._id,
        images: item.images,
        message: item.message,
        scope: item.scope,
        interest: item.interest,
        status: item.status,
        shop: item.shop,
        created_at: item.created_at,
      },
    });
  };


  const CustomDatePicker = React.forwardRef(({ value, onClick }, ref) => (
      <ButtonComponent
          type="primary"
          variant="contained"
          name={value}
          size="small"
          onClick={onClick} ref={ref}>
        {value}
      </ButtonComponent>
  ));

  const handleRestAll = (event) => {
    setFilterState("");
    setStatusState("");
    adminSearchShopSalesLog("", "", "", "", 0);
  }

  const handlePrevOffset = () => {
    const offset = offsetState > 30 ? offsetState - 30 : 0;
    setOffsetState(offset);
    adminSearchShopSalesLog(filterState, statusState, startdateState, executiveState, shopStatusState, logPriorityState, offset);
  }

  const handleNextOffset = () => {
    const offset = offsetState + 30;
    setOffsetState(offset);
    adminSearchShopSalesLog(filterState, statusState, startdateState, executiveState, shopStatusState, logPriorityState, offset);
  }

  const handleSaleLogAddDate = (update) => {
    setStartdateState(update.getTime());
    adminSearchShopSalesLog(filterState, statusState, update.getTime(), executiveState, shopStatusState, logPriorityState, offsetState);
  };

  const handleSaleLogFilter = (event) => {
    setFilterState(event.target.value);
    adminSearchShopSalesLog(event.target.value, statusState, startdateState, executiveState, shopStatusState, logPriorityState, 0);
  };

  const handleSaleLogStatusFilter = (event) => {
    setStatusState(event.target.value);
    adminSearchShopSalesLog(filterState, event.target.value, startdateState, executiveState, shopStatusState, logPriorityState, 0);
  };

  const handleSaleLogPriorityFilter = (event) => {
    setLogPriorityState(event.target.value);
    adminSearchShopSalesLog(filterState, statusState, startdateState, executiveState, shopStatusState, event.target.value, 0);
  };

  const handleShopStatusFilter = (event) => {
    setShopStatusState(event.target.value);
    adminSearchShopSalesLog(filterState, statusState, startdateState, executiveState, event.target.value, logPriorityState, 0);
  };

  const handleSalesLeadExecutive = (event) => {
    setExecutiveState(event.target.value);
    setOffsetState(0);
    adminSearchShopSalesLog("", statusState, startdateState, event.target.value, shopStatusState, logPriorityState, 0);
  }

  const saleslogfilter = getAdminShopLogReasonList();

  const inputSaleLogFilterOptions = saleslogfilter.map((item) => {
    const { value, label } = item;
    return (
        <MenuItem value={value}>{label}</MenuItem>
    );
  });

  const saleslogStatusfilter = getAdminShopLogStatusList();

  const inputSaleLogStatusFilterOptions = saleslogStatusfilter.map((item) => {
    const { value, label } = item;
    return (
        <MenuItem value={value}>{label}</MenuItem>
    );
  });

  const shopStatusfilter = getAdminShopStatusLogFilterList();

  const inputShopStatusFilterOptions = shopStatusfilter.map((item) => {
    const { value, label } = item;
    return (
        <MenuItem value={value}>{label}</MenuItem>
    );
  });

  const shopLogPriorityfilter = getAdminShopLogPriorityFilterList();

  const inputShopLogPriorityFilterOptions = shopLogPriorityfilter.map((item) => {
    const { value, label } = item;
    return (
        <MenuItem value={value}>{label}</MenuItem>
    );
  });

  const { executives } = execList;

  const inputExecutiveFilterOptions = executives.map((item) => {
    const { name, _id } = item;
    return (
        <MenuItem value={_id}>{name}</MenuItem>
    );
  });

  const history = useHistory();

  const handlePage = (page) => (e) => {
    history.push(page);
  };

  //const { categoryMode } = state;
  //const { selectedSaleLog = {} } = categoryState;

  const { selectedSaleLog = {} } = saleslogState;

  const renderNoResults = () => (
      <section className="cart-section section-b-space">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div>
                <div className="col-sm-12 empty-cart-cls text-center">
                  <H6>No saleslog found
                  </H6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  );

  const renderSaleLogResults = () => (
    <div>
        <Grid item container md={9} xs={12} spacing={4}>
          {saleslogs.map((saleslog, index) => (
              <Grid item xs={6} sm={4} key={index}>
              <AdminShopSalesLog
                className="product-item"
                key={saleslog.id}
                saleslog={saleslog}
                userDetails={bootupInfo.userDetails}
                isLoading={isLoading}
                editCategorySettings={handleSalesLogSetting("EDIT_SET", saleslog)}
              />
              </Grid>
          ))}
        </Grid>
    </div>
  );

  const renderSaleLogList = () => (
      <Container>
        <CustomFlexBox sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%'
        }}>
          {/*
          <Box width="25%" align="center">
            <SelectFieldComponent
                required
                options={inputSaleLogFilterOptions}
                label="Type"
                value={filterState}
                onChange={(event) => handleSaleLogFilter(event)}
            />
          </Box>
          */}
          <Box width="30%" align="center">
            <SelectFieldComponent
                required
                options={inputShopStatusFilterOptions}
                label="Shop Status"
                value={shopStatusState}
                onChange={(event) => handleShopStatusFilter(event)}
            />
          </Box>
          <Box width="30%" align="center">
            <SelectFieldComponent
                required
                options={inputSaleLogStatusFilterOptions}
                label="Log Status"
                value={statusState}
                onChange={(event) => handleSaleLogStatusFilter(event)}
            />
          </Box>
          <Box width="40%" align="center">
            <SelectFieldComponent
                required
                options={inputShopLogPriorityFilterOptions}
                label="Log Priority"
                value={logPriorityState}
                onChange={(event) => handleSaleLogPriorityFilter(event)}
            />
          </Box>
        </CustomFlexBox>
        <CustomFlexBox sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%'
        }}>
          <Box width="30%" align="center">
            <SelectFieldComponent
                sx={{margin: "4px"}}
                required
                options={inputExecutiveFilterOptions}
                label="Executive"
                value={executiveState}
                onChange={(event) => handleSalesLeadExecutive(event)}
            />
          </Box>
          <Box width="30%" align="center">
            Visit  Before:
            <DatePicker
                placeholderText="Select Date"
                selected={startdateState}
                maxDate={new Date(new Date().getTime() + 24 * 60 * 60 * 1000)}
                onChange={handleSaleLogAddDate}
                dateFormat="MMMM d, yyyy"
                customInput={<CustomDatePicker />}
            />
          </Box>
          <Box width="20%" align="right">
            {offsetState > 0 && <IconButton onClick={handlePrevOffset}>
              <ArrowBackIosIcon fontSize="medium" color="primary"/>
            </IconButton>
            }
          </Box>
          <Box width="20%" align="right">
            <IconButton onClick={handleNextOffset}>
              <ArrowForwardIosIcon fontSize="medium" color="primary"/>
            </IconButton>

          </Box>
        </CustomFlexBox>
        <CustomSectionCreator isSubtle={true} title="Shopana Sales Log" />
      {isLoading ? <MockProductList /> : saleslogs.length > 0 ? renderSaleLogResults() : renderNoResults()},

      </Container>
  );

  const renderCategoryEdit = () => {
    switch (saleslogModeState) {
      case "EDIT_SET":
      default:
        return (
          <AdminShopSalesLogSettingEditor
              {...props}
              setState={(value, field) => setSaleLogState({
                ...state,
                selectedSaleLog: {
                  ...selectedSaleLog,
                  [field]: value,
                },
              })}
            saleslog={selectedSaleLog}
              selectedSaleLog={selectedSaleLog}
              history={history}
              userDetails={bootupInfo.userDetails}
              updateSaleLogSettingClicked={updateSaleLogStatusCall}
              isLoading={isLoading}
              onCancel={() => setSaleLogModeState("PREVIEW")}
          />
        );
    }
  };

  return (
    <Container>
      {saleslogModeState === "PREVIEW" ? (
        renderSaleLogList()
      ) : (
        renderCategoryEdit(saleslogModeState)
      )}
    </Container>
  );
};

AdminSalesLogMain.defaultProps = {
  isLoading: false,
  serviceError: "",
  reqStatus: "",
  saleslogs: [],
};

AdminSalesLogMain.propTypes = {
  isLoading: PropTypes.bool,
  serviceError: PropTypes.string,
  reqStatus: PropTypes.string,
  searchsaleslogs: PropTypes.objectOf(PropTypes.any).isRequired,
  bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
  adminSearchSaleLogs: PropTypes.func.isRequired,
  adminUpdateSaleLog: PropTypes.func.isRequired,
};

const adminSalesLogMain = connect(
  ({ adminShops, adminSales, bootupInfo }) => ({
    bootupInfo,
    userDetails: bootupInfo.userDetails,
    reqStatus: adminShops.reqStatus,
    isLoading: adminShops.isLoading,
    serviceError: adminShops.serviceError,
    saleslogs: adminShops.searchsaleslogs,
    execList: adminSales.execList,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(AdminSalesLogMain);

export default adminSalesLogMain;
